<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane :label="`商品`" name="sku"> </el-tab-pane>
        <el-tab-pane :label="`产品`" name="product"> </el-tab-pane>
        <el-tab-pane :label="`包件`" name="pack"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" :ref="activeName" @searchForm="getsearchForm"></component>
    </content-panel>
  </div>
</template>

<script>
import sku from "./sku/sku";
import product from "./product/product";
import pack from "./pack/pack";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "LiveBroadcast",
  mixins: [pagePathMixin],
  components: { sku, product, pack },
  data() {
    return {
      activeName: "sku",
      searchForm: {},
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  watch: {
    //商品切换到产品  产品切换到包件 代入直播批次和店铺筛选条件
    activeName(val, old) {
      if (val == "product" && old == "sku") {
        this.$nextTick((_) => {
          let { liveBatchName, storeName, all, all2 } = this.searchForm;
          this.$refs["product"].searchForm.liveBatchName = liveBatchName;
          this.$refs["product"].searchForm.storeName = storeName;
          this.$refs["product"].all = all;
          this.$refs["product"].all2 = all2;
        });
      } else if (val == "pack" && old == "product") {
        this.$nextTick((_) => {
          let { liveBatchName, storeName, all, all2 } = this.searchForm;
          this.$refs["pack"].searchForm.liveBatchName = liveBatchName;
          this.$refs["pack"].searchForm.storeName = storeName;
          this.$refs["pack"].all = all;
          this.$refs["pack"].all2 = all2;
        });
      }
    },
  },
  mounted() {},
  methods: {
    handleClick() {},
    getsearchForm(form) {
      this.searchForm = form;
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
